import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import {ScrollDirection} from '../classes/scroll-manager';
import {getEl} from '../helpers';
import AnimationDebugger from '../components/animation-debugger';

export default class Extro extends Scene {

	sectionSelector = '#extro';
	mediaTimeline = anime.timeline({
		easing: 'easeInOutCubic',
		duration: 5000,
		autoplay: false,
		delay: 0,
	});
	
	observer: IntersectionObserver;

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);


		this.mediaTimeline
			.add({
				easing: 'easeInOutSine',
				targets: '.extro-img img',
				scale: [0.9, 1.1],
				translateY: [
					{value: '0%'},
					{value: '5%', duration: 4000},
					{value: '4%', duration: 2000},
					{value: '3%'},
				],
				duration: 5000,
			}, 0)
			.add({
				targets: '.extro-heading-1',
				translateX: ['-50%', '-50%'],
				opacity: [
					{value: 0, duration: 0},
					{value: 1, duration: 1500},
					{value: 1, duration: 3000},
					{value: 0, duration: 1500},
				],
				translateY: [
					{value: '-20%', duration: 0},
					{value: '-50%', duration: 1500},
					{value: '-50%', duration: 3000},
					{value: '-100%', duration: 1500},
				],
			}, 200)
			.add({
				targets: '.extro-heading-2',
				translateX: ['-50%', '-50%'],
				opacity: [
					{value: 0, duration: 0},
					{value: 1, duration: 1500},
					{value: 1, duration: 5000},
					{value: 0, duration: 1500},
				],
				translateY: [
					{value: '-20%', duration: 0},
					{value: '-50%', duration: 1500},
					{value: '-50%', duration: 5000},
					{value: '-100%', duration: 1500},
				],
			}, 5200)
			.add({
				targets: '.extro-headings',
				clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
				opacity: [0,1],
				duration: 1000,
			}, 0)
			.add({
				targets: '.extro-wipes .extro-wipe',
				clipPath: ['inset(100% 0% 0% 0%)', 'inset(0% 0% 0% 0%)'],
				delay: anime.stagger(5000, {start: 0}),
				duration: 1000,
			}, 0)
			.add({
				targets: '.extro-wipes .extro-wipe-1 img',
				scale: [1, 1.15],
				translateY: ['0%', '-5%'],
				easing: 'easeOutSine',
				duration: 6000,
			}, 0)
      .add({
          targets: '.extro-wipes .extro-wipe-2 img',
          scale: [1.8, 1],
          translateY: ['10%', '0%'],
          easing: 'easeOutSine',
          duration: 8000,
      }, 5000)
			.add({
				targets: '.extro-headings',
				opacity: 0,
				duration: 1000,
			}, 10500)
      .add({
          targets: '.extro-scroll-to-continue',
          opacity: [0,1],
          duration: 2000,
      }, 10000);

		//Uncomment this to attach an animation debugger.
		//const animDebug = new AnimationDebugger(this.mediaTimeline, getEl('.extro-sticky'));

		
		this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
			threshold: 0
		});
		
		this.observer.observe(getEl('#extro'));
		
	}
	
	onIntersection(entries: IntersectionObserverEntry[], observer: IntersectionObserver)
	{
		entries.forEach((item) => {
			if (item.isIntersecting)
			{
				if (!this.mediaTimeline.completed) this.mediaTimeline.play();
				this.mediaTimeline.restart();
			} else {
				
				this.mediaTimeline.seek(0);
				this.mediaTimeline.completed = false;
			}
		})
	}
	
	
	onExitedView(dir: ScrollDirection) {

	}

	onEnteredView(dir: ScrollDirection) {
	
	}

}
